import { isValidArray } from '@/utils/isValidArray';
import checkProductCardShowMkplSection from '@/utils/mkpl/checkProductCardShowMkplSection';
import { ProductTags } from '../constants';
import { StatusEnum } from '@/types/cart';
import { CardType, ProductCardProps } from '../types';
import { getRemainingCount } from '@/utils/common/product-card';

export const arrayToObject = (arr: ObjectType[]) => {
  const obj = arr.reduce((accumulator, current) => {
    accumulator[current.key] = current.show;
    return accumulator;
  }, {});
  return obj;
};

export const checkIsShowInfos = (props: Partial<ProductCardProps & CardType>, activityTagLimit = null) => {
  const {
    data,
    showActivity = true,
    showSoldBy = true,
    showAllTags = true,
    showRankTag = true,
    showLeft = true,
    showWeekly = true
  } = props;

  const { showShipsFrom, showEta } = checkProductCardShowMkplSection(data, activityTagLimit);
  const remainCount = getRemainingCount(data);
  const isSoldOut = data?.sold_status === StatusEnum?.sold_out;
  const rankData = data?.entrance_tag;
  const weekSoldCount = data?.sold_count_ui !== '0' ? data?.sold_count_ui : '';

  // Tips: conditions的顺序是优先级的顺序
  const conditions = [
    {
      key: ProductTags.PRE_SALE,
      show: !!data?.is_presale && !isSoldOut
    },
    {
      key: ProductTags.ACTIVITY,
      show: showActivity && isValidArray(data?.product_tag_list)
    },
    {
      key: ProductTags.SHIPS_FROM,
      show: showSoldBy && showShipsFrom
    },
    {
      key: ProductTags.RANKING,
      show: showAllTags ? !!rankData : showRankTag && !!rankData
    },
    {
      key: ProductTags.ETA,
      show: showSoldBy && showEta
    },
    {
      key: ProductTags.LEFT,
      show: showAllTags ? !!remainCount : showLeft && !!remainCount
    },
    {
      key: ProductTags.WEEKLY_SOLD,
      show: showWeekly && !!weekSoldCount
    }
  ];

  const showMap = arrayToObject(conditions.filter(condition => condition.show));

  return showMap;
};
